import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from 'prop-types';
/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number;
  alt?: string;
}
function IconInfoDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M12 4.722a7.778 7.778 0 1 0 0 15.556 7.778 7.778 0 0 0 0-15.556M2 12.5c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M12 11.965c.592 0 1.072.48 1.072 1.071v2.679a1.071 1.071 0 1 1-2.143 0v-2.679c0-.591.48-1.071 1.071-1.071" clipRule="evenodd" /><path fill="currentColor" d="M13.072 9.286a1.071 1.071 0 1 1-2.143 0 1.071 1.071 0 0 1 2.143 0" /></svg></>;
}
IconInfoDefault.propTypes = ({
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
} as PropTypes.ValidationMap<Props>);
export default IconInfoDefault;